import React, { FC } from 'react';
import MuiSwitch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import { LockIcon } from '../SkladonIcon/SmallIcons';
import { SxProps, Theme } from '@mui/material/styles';

export interface SwitchPropsType {
    value?: boolean;
    onChange?: (checked: boolean) => void;
    disabled?: boolean;
    label?: string;
    sx?: SxProps<Theme>;
}

const Switch: FC<SwitchPropsType> = (props) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
        if (props.onChange) {
            props.onChange(checked);
        }
    };

    return (
        <FormControlLabel
            value="start"
            control={
                <>
                    {props.disabled && <LockIcon />}
                    <MuiSwitch checked={!!props.value} onChange={handleChange} disabled={props.disabled} />
                </>
            }
            sx={props.sx}
            label={props.label}
            labelPlacement="start"
            className="input-switch"
            disabled={props.disabled}
        />
    );
};

export default Switch;
